import { SvgIconProps } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { ClientConfigState } from 'services/redux/clientConfigSlice';

const IconWrapper = ({
  children,
  color = 'primary',
  sx,
  ...props
}: SvgIconProps) => {
  const config = useSelector(
    (state: { clientConfiguration: ClientConfigState }) =>
      state.clientConfiguration.configs,
  );

  const customPrimaryColor = config?.pruffConnect_styles_mainColor;
  const customSecondaryColor = config?.pruffConnect_styles_secondaryColor;
  const useCustomColor = color === 'primary' && !!customPrimaryColor;
  const useSecondaryColor = color === 'secondary' && !!customSecondaryColor;
  const iconColor = useCustomColor || useSecondaryColor ? undefined : color;
  const htmlColor = useCustomColor
    ? customPrimaryColor
    : useSecondaryColor
      ? customSecondaryColor
      : undefined;

  return React.cloneElement(children as React.ReactElement, {
    ...props,
    color: iconColor,
    htmlColor,
    sx: {
      ...sx,
    },
  });
};

export default IconWrapper;
